import Button from "../../../../components/ui/Button";
import Card, { CardBody } from "../../../../components/ui/Card";
import Modal, { ModalBody, ModalFooter, ModalFooterChild, ModalHeader } from "../../../../components/ui/Modal";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { setAsMainPicture } from "../../../../services/vizyBilityServices";
import AddLocationModel from "../../locationInfo/addLocationModel";
import { getLocationsByCompanyId } from "../../../../services/locationService";
import { logoutFun } from "../../../../utils/helper";
import { useMsal } from "@azure/msal-react";
import Icon from "../../../../components/icon/Icon";
import classNames from "classnames";
import themeConfig from "../../../../config/theme.config";
import Radio, { RadioGroup } from "../../../../components/form/Radio";

const SelectLocationModel = ({ modalStatus, setModalStatus, refresh, handleSelectLocation, selectLocationId }) => {
  const { instance, accounts } = useMsal();
  const [isLoading, setIsLoading] = useState(false);
  const [defaultSelect, setDefaultSelect] = useState(selectLocationId);
  const [addLocationModel, setAddLocationModel] = useState(false);
  const [editLocationModel, setEditLocationModel] = useState(false);
  const [selectEditLocationId, setSelectEditLocationId] = useState(null);
  const [locationList, setLocationList] = useState([]);
  const azureUserInfo = localStorage.getItem("getAzureUserData")
    ? JSON.parse(localStorage.getItem("getAzureUserData") || {})
    : null;

  useEffect(() => {
    GetLocationList();
  }, []);

  const handleRefreshLocationList = () => {
    GetLocationList();
    refresh();
  };

  const GetLocationList = () => {
    setIsLoading(true);
    const header = {
      authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
    };
    getLocationsByCompanyId(Number(azureUserInfo?.CompanyId), header, instance, accounts)
      .then((res) => {
        // setPagination({
        //   ...pagination,
        //   totalRecords: res.data.length,
        //   pageCount: res.data.length,
        // });
        setLocationList(res.data);
        setIsLoading(false);
      })
      .catch((err) => {
        if (err?.status == 401 || err?.statusText == "Unauthorized") {
          logoutFun(instance);
        }
      });
  };
  return (
    <>
      <Modal
        isOpen={modalStatus}
        setIsOpen={setModalStatus}
        isAnimation={true}
        isCentered={true}
        isScrollable={true}
        isStaticBackdrop={"rounded-3xl"}
        size={"sm"}
      >
        <ModalHeader>Select Location</ModalHeader>
        <ModalBody>
          <div className="flex justify-end mb-[20px]">
            <Button
              className="cursor-pointer flex items-center !text-black text-[16px] !bg-[#FEBA06]"
              onClick={() => {
                setAddLocationModel(true);
                setSelectEditLocationId(null);
                setEditLocationModel(false);
              }}
            >
              <Icon
                icon={"HeroPlus"}
                className={classNames(
                  "text-[22px] fill-black  text-black cursor-pointer mr-[5px]",
                  themeConfig.transition
                )}
              />{" "}
              Add Location
            </Button>
          </div>
          <RadioGroup>
            {locationList?.map((item, index) => {
              return (
                <div className="mb-[20px] flex justify-between">
                  <div className="flex items-start mr-[20px]">
                    <div className="mr-[20px]">
                      <Radio
                        key={index}
                        // label={item.LocationName}
                        name="radioOption"
                        value={Number(item?.LocationId)}
                        selectedValue={Number(defaultSelect)}
                        onChange={(e) => {
                          setDefaultSelect(e.target.value);
                        }}
                        color={"blue"}
                      />
                    </div>
                    <div className="flex flex-col">
                      <div className="font-bold mb-[5px]">{item.LocationName}</div>
                      <div className="mb-[5px]">
                        {item.Address1} {item.Address2} {item.Province} {item.City} {item.PostalCode}
                      </div>
                    </div>
                  </div>
                  <div>
                    <Button
                      className="cursor-pointer flex items-center !text-black text-[16px] !bg-[#FEBA06]"
                      onClick={() => {
                        setSelectEditLocationId(item?.LocationId);

                        setEditLocationModel(true);
                      }}
                    >
                      <Icon
                        icon={"EditIcon"}
                        className={classNames(
                          "text-[16px]  dark:text-transparent text-transparent fill-black cursor-pointer mr-[5px] ",
                          themeConfig.transition
                        )}
                      />{" "}
                      Edit
                    </Button>
                  </div>
                </div>
              );
            })}
          </RadioGroup>
        </ModalBody>

        <ModalFooter className="mt-[20px]">
          <ModalFooterChild></ModalFooterChild>
          <ModalFooterChild>
            <Button
              onClick={() => setModalStatus(false)}
              className="cursor-pointer flex items-center !text-white text-[16px] !bg-[#cb3b41]"
            >
              Close
            </Button>
            <Button
              onClick={() => handleSelectLocation(defaultSelect)}
              className="cursor-pointer flex items-center !text-black text-[16px] !bg-[#FEBA06]"
            >
              Ok
            </Button>
          </ModalFooterChild>
        </ModalFooter>
      </Modal>

      {addLocationModel && (
        <AddLocationModel
          modalStatus={addLocationModel}
          setModalStatus={setAddLocationModel}
          refreshLocationList={handleRefreshLocationList}
        />
      )}

      {editLocationModel && (
        <AddLocationModel
          modalStatus={editLocationModel}
          setModalStatus={setEditLocationModel}
          refreshLocationList={handleRefreshLocationList}
          LocationID={selectEditLocationId}
        />
      )}
    </>
  );
};
export default SelectLocationModel;
